const servicioObjetos = {

  asignarAtributosObjeto(event, _this, toUpperCase,sinAcentos) {
    let nombrePropiedad = event.target.name;
    let valorPropiedad = event.target.value;
    
    if(sinAcentos){
      valorPropiedad =this.quitarAcentos(valorPropiedad);
        //valorPropiedad=  valorPropiedad.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    if (toUpperCase) {
      if (valorPropiedad && typeof valorPropiedad !== 'object')
        valorPropiedad = valorPropiedad.toUpperCase();
    }
    let elementos = nombrePropiedad.split(".");    
    let objeto = _this.state[elementos[0]];
    if (elementos.length > 2) {
      var nombreObjeto = elementos[1];
      var laPropiedad = elementos[2];
      // if (objeto.hasOwnProperty(nombreObjeto)) {
      //   objeto[nombreObjeto] = {};
      // }
      objeto[nombreObjeto][laPropiedad] = valorPropiedad;
    } else {      
      let nombreAtributoObjetoState = elementos[1];
      objeto[nombreAtributoObjetoState] = valorPropiedad;
    }
    _this.setState({ objeto });
  },

   quitarAcentos(cadena){
    const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
    return cadena.split('').map( letra => acentos[letra] || letra).join('').toString();	
  },

  esObjetoVacio(objeto) {     
    if (objeto === undefined)
      return true;
      
    if (objeto === null)
      return true;
      
    if (objeto.length > 0)      
      return false;
      
    if (objeto.length === 0)
      return true;
          
    if (objeto === true)
      return false;    
      
    if (Object.keys(objeto).length > 0)
      return false;
    

    if (JSON.stringify(objeto) === JSON.stringify({}))
      return true;
      
    for (var key in objeto) {
      if (hasOwnProperty.call(objeto, key))
        return false;              
    }
    if (typeof objeto === 'number')
      return false;
          
    if (JSON.stringify(objeto).length > 0)
        return false; 
    return true;
  },
  eliminarObjetoMapa(arreglo, elemento) {
    const indice = arreglo.indexOf(elemento);
    arreglo.splice(indice, 1);
  },
  obtenerObjetoDeArregloPorPropiedad(arreglo, identificador, valor) {
    for (var i = 0; i < arreglo.length; i++) {
      if (arreglo[i][identificador] === valor) {
        return arreglo[i];        
      }
    }
    return null;
  },stripToEmpty(value){
    if(this.esObjetoVacio(value))
      return "";
    return value.trim();
  }
}

export default servicioObjetos;